import { inject, Injectable, OnDestroy } from '@angular/core';
import { selectIsSuperAdmin } from '@elite/authentication/domain';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { enableDevToolsForSuperAdmin } from './disable-devtools';

/**
 * Watches the NgRx store for super admin status.
 * When the logged-in user is confirmed as super admin, all DevTools restrictions
 * set by `disableBrowserDevTools()` are lifted for the session.
 */
@Injectable()
export class DevToolsGuardService implements OnDestroy {
  private readonly store = inject(Store);
  private readonly sub: Subscription;

  constructor() {
    this.sub = this.store
      .select(selectIsSuperAdmin)
      .pipe(
        filter((isSuperAdmin) => isSuperAdmin === true),
        take(1),
      )
      .subscribe(() => enableDevToolsForSuperAdmin());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
